import { queryKeyFactory } from "@l2r-front/l2r-query"

export const DOCUMENT_ROOT_QUERY_KEY = "document"

export const documentQueryKeys = queryKeyFactory(DOCUMENT_ROOT_QUERY_KEY, {
    authors: (filters = {}) => [DOCUMENT_ROOT_QUERY_KEY, "authors", filters],
    elementType: (typeCode, filters = {}) => [DOCUMENT_ROOT_QUERY_KEY, "elementType", typeCode, filters],
    element: (elementId, filters = {}) => [DOCUMENT_ROOT_QUERY_KEY, "element", elementId, filters],
    project: (filters = {}) => [DOCUMENT_ROOT_QUERY_KEY, "project", filters],
    types: (filters = {}) => [DOCUMENT_ROOT_QUERY_KEY, "types", filters],
    verticalSignTypes: (type = null) => [DOCUMENT_ROOT_QUERY_KEY, "verticalSign", type],
})
